<div class="account-details-page">
  <div class="container">
    <!-- Account Details -->
    <section class="account-details">
      <h2>Account Details</h2>
      <p class="description">
        See information about your account and service details.
      </p>

      <div class="divider"></div>
      <div class="details-grid">
        <div class="detail-item">
          <p>Account ID</p>
          <span class="value">288</span>
        </div>
        <div class="detail-item">
          <p>Account Status</p>
          <span class="status active">Active</span>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="firstName">First name</label>
          <input id="firstName" type="text" value="Warren van der Merwe" />
        </div>
        <div class="form-group">
          <label for="lastName">Last name</label>
          <input id="lastName" type="text" />
        </div>
        <div class="form-group">
          <div class="flex justify-between items-center">
            <label>Email</label>
            <a href="#" class="update-link">Update your email</a>
          </div>
          <div class="inline-field">
            <input type="email" value="warren@loudcountyfiber.com" />
          </div>
        </div>
        <div class="form-group">
          <div class="flex justify-between items-center">
            <label>Phone number</label>
            <a href="#" class="update-link">Update your phone number</a>
          </div>
          <div class="inline-field">
            <input type="text" value="Mobile: +1 317-500-1369" />
          </div>
        </div>
      </div>
    </section>

    <!-- Service Details -->
    <section class="service-details">
      <h2 class="section-title">
        <span class="icon"
          ><img src="/dashboard/support/home.svg" alt="home"
        /></span>
        Service Details
      </h2>
      <div class="divider"></div>
      <div class="details-cards">
        <div class="w-4/12">
          <div class="card flex items-start">
            <img src="/dashboard/support/1.png" alt="" />
            <div class="content">
              <p>Service address</p>
              <span
                >20277 Cockerill Road<br />Purcellville, VA 20132<br />United
                States</span
              >
            </div>
          </div>
        </div>
        <div class="w-4/12">
          <div class="card flex items-start">
            <img src="/dashboard/support/2.png" alt="" />
            <div class="content">
              <p>Mailing address</p>
              <span
                >20277 Cockerill Road<br />Purcellville, VA 20132<br />United
                States</span
              >
            </div>
          </div>
        </div>

        <div class="w-4/12">
          <div class="card flex items-start">
            <img src="/dashboard/support/3.png" alt="" />
            <div class="content">
              <p>Subscription date</p>
              <span>January 3, 2024<br />United States</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Security -->
    <section class="security">
      <h2 class="section-title"><img src="/dashboard/support/4.png" alt="support"> Security</h2>
      <div class="divider"></div>
      <p>Password</p>
      <span>Last changed December 25, 2024</span>
      <a href="#" class="update-link">Update your password</a>
    </section>
  </div>
</div>
